import axios from 'axios'

export const consultants = {
    state: {
        consultant: [],
        consultantbyid: [],
        bellcount: '',
        consultantAvailable:''
    },
    mutations:{
        consultant(state, data){
          state.consultant = data.consultants
        },
        consultantbyid(state, data){
          state.consultantbyid = data.consultant
        },
        bellcount(state, data){
          state.bellcount = data.countUnread
        },
      setConsultantAvailable(state, consultant) {
        state.consultantAvailable=consultant
      },
    },
    actions:{
        getConsultants: ({commit})=>{
            return new Promise((resolve, reject)=>{
                axios.get("/consultants")
                .then(({status, data})=>{
                  if(status === 200){
                    resolve(data);
                    commit("consultant", data)
                  }
                })
                .catch((error)=>{
                  reject(error);
                });
              })
        },
        BellCount: ({commit},payload)=>{
          return new Promise((resolve, reject)=>{
            axios.get("/notifications?username="+payload)
            .then(({status, data})=>{
              if(status === 200){
                resolve(data);
                commit("bellcount",data)
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
        },
        deleteConsultant: ({commit},payload)=>{
          return new Promise((resolve, reject)=>{
            axios.delete("/consultants/"+payload)
            .then(({status, data})=>{
              if(status === 200){
                resolve(data)
              }
            })
            .catch((error)=>{
              reject(error);
            })
          });
        },
        ConsultantById :({commit},payload) =>{
            return new Promise((resolve, reject)=>{
                axios.get("/consultants/"+payload)
                .then(({status, data})=>{
                  if(status === 200){
                    resolve(data)
                    commit('consultantbyid', data)
                  }
                })
                .catch((error)=>{
                  reject(error);
                })
              });  
        },
        registerConsultant: ({commit},payload)=>{
          return new Promise((resolve, reject)=>{
            axios.post("/consultants",payload)
            .then(({data, status})=>{
              if(status === 201){
                resolve(data);
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
        },
        forgotPassword: ({commit},payload)=>{
          return new Promise((resolve, reject)=>{
            axios.post("/consultants/forgotpassword",payload)
            .then(({data, status})=>{
              if(status === 200){
                resolve(data);
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
        },
        changePassword: ({commit},payload)=>{
          return new Promise((resolve, reject)=>{
            axios.post("/consultants/resetPassword",payload)
            .then(({data, status})=>{
              if(status === 200){
                resolve(data);
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
        },
        UpdateProfile: ({commit},payload)=>{
        var bodyFormData = new FormData();
        bodyFormData.set('consultantUsername', payload.username);
        bodyFormData.set('firstName', payload.firstname);
        bodyFormData.set('lastName', payload.lastname);
        bodyFormData.set('phoneNumber', payload.contact);
        bodyFormData.set('email',  payload.email);
        bodyFormData.set('type',  payload.type);
        bodyFormData.append('profileImg', payload.image);
        console.log(bodyFormData)
        console.log(payload.firstname)
        console.log(payload.lastname)
        console.log(payload.contact)
        console.log(payload.email)
        console.log(payload.type)
        return new Promise((resolve, reject)=>{
          axios({
            method: 'put',
            url: '/consultants',
            data: bodyFormData,
            config: { }
                })
            .then((data) => {
              resolve(data)
                })
                .catch((error)=>{
                  reject(error)
             });
        })
      },
      UpdateRole: ({commit},payload)=>{
        return new Promise((resolve, reject)=>{
          axios.put("/consultants",payload)
          .then(({data, status})=>{
            if(status === 200){
              resolve(data);
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      updateMemberRole: ({commit},payload)=>{
        return new Promise((resolve, reject)=>{
          axios.post("/members/roles",payload)
          .then(({data, status})=>{
            if(status === 200){
              resolve(data);
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },

      // ================check if username is available================
      isConsultantAvailable ( { commit }, {username} ){
        return new Promise ((resolve,reject)=>{
          axios.get('/consultant/name/availability/' +username)
          .then((data)=>{
            resolve(data.data.isAvailable)
            const consultant = data.data.isAvailable
            commit ('setConsultantAvailable', consultant)
            console.log(consultant);
          })
          .catch((error)=>{
              reject(error)
              console.log(error)
          })
        })
    },
    }

}